module.exports = __webpack_public_path__ + "static/Rust_Monster-537f8c8af39a09f5cbd921f3e99fc0c6.jpg";